import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import {
  FileText,
  Target,
  PenTool,
  Megaphone,
  BarChart3,
  LineChart,
} from "lucide-react";
import pic1 from "../../assets/images/It services.jpg";
import { useNavigate, Link } from "react-router-dom";
// import {  } from "react-router-dom";;

const ItService = () => {
  const [formData, setFormData] = React.useState({
    service: "",
    name: "",
    email: "",
    phone: "",
    subject: "",
    description: "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Form submitted successfully!");
    setFormData({
      service: "",
      name: "",
      email: "",
      phone: "",
      subject: "",
      description: "",
    });
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  const navigate = useNavigate();

  // Foundation pillars data
  // const content = [
  //   {
  //     icon: <FileText className="h-8 w-8" />,
  //     title: "🚀 UI/UX Design",
  //     description:
  //       "Seamless, intuitive, and engaging user experiences tailored to meet your brand's digital needs",
  //   },
  //   {
  //     icon: <Target className="h-8 w-8" />,
  //     title: "🌐 Web Development",
  //     description:
  //       "Responsive, scalable, and secure websites designed to support your business growth.",
  //   },
  //   {
  //     icon: <PenTool className="h-8 w-8" />,
  //     title: "🎨 Graphic Designing",
  //     description:
  //       "Visually striking designs that communicate your brand's identity and core messaging.",
  //   },
  //   {
  //     icon: <Megaphone className="h-8 w-8" />,
  //     title: "🔍 Search Engine Optimization (SEO)",
  //     description:
  //       "Boost your online visibility with our proven SEO strategies that drive organic traffic and higher search rankings.",
  //   },
  //   {
  //     icon: <BarChart3 className="h-8 w-8" />,
  //     title: "📈 Social Media Marketing",
  //     description:
  //       "Targeted campaigns and engaging content that connect with your audience and achieve marketing goals.",
  //   },
  // ];

  const content = [
    {
      icon: <FileText className="h-8 w-8" />,
      title: "🚀 UI/UX Design",
      description:
        "Seamless, intuitive, and engaging user experiences tailored to meet your brand's digital needs",
      link: "/uiux",
    },
    {
      icon: <Target className="h-8 w-8" />,
      title: "🌐 Web Development",
      description:
        "Responsive, scalable, and secure websites designed to support your business growth.",
      link: "/web",
    },
    {
      icon: <PenTool className="h-8 w-8" />,
      title: "🎨 Graphic Designing",
      description:
        "Visually striking designs that communicate your brand's identity and core messaging.",
      link: "/graphics",
    },
    {
      icon: <Megaphone className="h-8 w-8" />,
      title: "🔍 Search Engine Optimization (SEO)",
      description:
        "Boost your online visibility with our proven SEO strategies that drive organic traffic and higher search rankings.",
      link: "/seo",
    },
    {
      icon: <BarChart3 className="h-8 w-8" />,
      title: "📈 Social Media Marketing",
      description:
        "Targeted campaigns and engaging content that connect with your audience and achieve marketing goals.",
      link: "/social",
    },
  ];

  return (
    <div
      className="bg-gray-100 text-gray-800"
      style={{ marginTop: "80px" }}
      data-aos="fade-up"
    >
      <motion.header
        className="bg-blue-900 text-white py-16 text-center shadow-lg rounded-lg"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-gradient-to-r from-blue-50 to-indigo-100 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-white">
                  🚀 Drive Your Business on the Wheels of{" "}
                </span>
                <span className="text-blue-600">Digitalization</span>
              </h1>
              <p className="mt-4" style={{ fontWeight: "bold" }}>
                Revolutionize your business with cutting-edge digital solutions.
              </p>
              <p className="text-white mb-8 mt-4">
                At Right On Time Services, we position your brand at the
                forefront of the digital world through our innovative and
                tailored services.
              </p>
              <button
                onClick={() => navigate("/bookmeeting")}
                style={{ color: "black" }}
                className="mt-4 bg-white text-blue-700 px-6 py-3 font-bold rounded-full hover:bg-blue-100 transition"
              >
                Free Consultation
              </button>
            </div>
          </div>
        </div>
      </motion.header>

      {/* About Section */}
      <motion.section className="py-16 bg-gray-100 mx-auto" data-aos="fade-up">
        <section className="py-16 bg-white px-4 md:px-10" data-aos="fade-up">
          <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-3xl font-bold text-blue-900 mb-6 text-left">
                📱 About Digital Transformation
              </h2>
              <p className="mb-6 text-gray-700 max-w-xl">
                At Right On Time Services, we are a full-service digital
                solutions agency, offering end-to-end digital marketing, graphic
                design, and web development services. Our data-driven strategies
                and skilled team deliver measurable results through:
              </p>

              <div className="grid gap-6">
                {[
                  "Search Engine Optimization (SEO)",
                  "Pay-Per-Click (PPC) Advertising",
                  "Social Media Management",
                  "Email and Content Marketing",
                ].map((item, idx) => (
                  <motion.div
                    key={idx}
                    className="p-6 bg-white rounded-lg shadow-md hover:shadow-2xl transition duration-300"
                    whileHover={{ scale: 1.05 }}
                  >
                    <h3 className="text-xl font-bold text-blue-900">{item}</h3>
                  </motion.div>
                ))}
              </div>

              <p className="mt-6 text-gray-700 max-w-xl">
                We specialize in crafting responsive websites, running impactful
                social media campaigns, and creating engaging digital content.
                With a commitment to transparency and client satisfaction, our
                goal is to help businesses grow and thrive in the digital era.
              </p>
            </div>

            {/* Right Image */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="flex justify-center"
            >
              <img
                src={pic1} // ← Replace with your actual image path
                alt="Digital Transformation Illustration"
                className="w-full max-w-md h-auto object-contain rounded-xl"
              />
            </motion.div>
          </div>
        </section>
      </motion.section>

      {/* Why Choose Us? */}
      <div className="py-20 bg-gray-50 duration-1000 mb-16" data-aos="fade-up">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold mb-4">
              🌟 Our Comprehensive Services
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {content.map((item, i) => (
              <div key={i} className="p-4 shadow rounded bg-white">
                {item.icon}
                <h3 className="text-xl font-bold mt-2">{item.title}</h3>
                <p className="text-gray-600 mt-1">{item.description}</p>
                <Link
                  to={item.link}
                  className="mt-3 text-blue-600 hover:underline inline-block"
                >
                  Read More →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Services Section */}
      <section className="py-16 bg-gray-100" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-blue-900 text-center">
          Our Proven Process
        </h2>

        {/* <p className="mt-4 px-8 max-w-4xl mx-auto">We Create Visuals that Leave a Lasting Impression!</p> */}
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-2 gap-8 px-8 mt-6"
          style={{ marginTop: "30px" }}
        >
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-blue-900">
              Our Proven Process
            </h3>
            <p className="mt-2">Understand client goals and market trends</p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-blue-900">UI/UX Design</h3>
            <p className="mt-2">Craft engaging and user-centric designs.</p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-blue-900">Branding</h3>
            <p className="mt-2">Build strong brand identities</p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-blue-900">User Testing</h3>
            <p className="mt-2">Ensure seamless user experiences.</p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-blue-900">Development</h3>
            <p className="mt-2">
              Deliver responsive and functional digital solutions
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-blue-900">Marketing</h3>
            <p className="mt-2">Execute data-driven marketing strategies.</p>
          </motion.div>
        </div>
      </section>

      <motion.section className="py-16 bg-gray-100 mx-auto" data-aos="fade-up">
        <section className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-blue-900 text-center">
            🌟 Featured Work
          </h2>
          <p className="mt-4" style={{ textAlign: "center" }}>
            Explore our portfolio showcasing successful digital transformations
            and innovative solutions delivered to our valued clients.
          </p>
        </section>
      </motion.section>

      {/* Services Section */}
      <section
        className="py-16"
        style={{ background: "white" }}
        data-aos="fade-up"
      >
        <h2 className="text-3xl font-bold text-blue-900 text-center">
          Why Choose Right On Time Services?
        </h2>
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-2 gap-8 px-8 mt-6"
          style={{ marginTop: "30px" }}
        >
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-blue-900">
              ✨ Comprehensive Solutions{" "}
            </h3>
            <p className="mt-2">
              End-to-end digital marketing, design, and development services.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-blue-900">
              👩‍💻 Skilled Professionals
            </h3>
            <p className="mt-2">
              A team with years of industry experience and creative expertise.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-blue-900">
              📊 Measurable Results
            </h3>
            <p className="mt-2">
              Data-driven approaches that ensure visible, quantifiable outcomes.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-blue-900">
              🤝 Client-Centric Approach
            </h3>
            <p className="mt-2">
              Transparent processes with a focus on long-term client
              partnerships.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-blue-900">
              💡 Competitive Pricing{" "}
            </h3>
            <p className="mt-2">
              Affordable solutions without compromising on quality
            </p>
          </motion.div>
        </div>
      </section>

      {/* Call to Action */}
      <motion.section
        data-aos="fade-up"
        className="py-16 text-center bg-white d-md rounded-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h2 className="text-3xl font-bold text-blue-900">
          🚀 READY TO START YOUR PROJECT?
        </h2>
        <button
          onClick={() => navigate("/bookmeeting")}
          className="mt-4 px-6 py-3 bg-blue-900 text-white font-bold rounded-lg shadow-lg hover:shadow-2xl hover:bg-blue-700 transition duration-300"
        >
          ✅ Let’s Start Together 💡
        </button>
      </motion.section>

      <section id="contact-inbound-call" className="py-20 bg-gray-50 mt-4 mb-4">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-blue-900 mb-4">
            🚀 Ready to Optimize Your Inbound Call System?
          </h2>
          <p className="text-base mb-6">
            Let’s Get Started – Together!
            <br />
            Contact Right On Time Services today and enhance your inbound call
            management.
          </p>
          <div className="text-sm text-gray-800 space-y-2">
            <p>
              📧 Email:{" "}
              <a
                href="mailto:info@rightontimeservices.com"
                className="text-blue-700 hover:underline"
              >
                info@rightontime.biz
              </a>
            </p>
            <p>
              📍 Address: Al-Rehman Chamber, Fazal e Haq Road, G 7/3 Blue Area,
              Islamabad, 44000 Rawalpindi.
            </p>
            <p>
              📞 Phone:{" "}
              <a
                href="tel:03394017907"
                className="text-blue-700 hover:underline"
              >
                03394017907
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      {/* <section id="contact" className="py-20 mb-16 bg-white" data-aos="fade-up">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold mb-4">Get in Touch</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Fill out the form below and we'll get back to you as soon as
              possible.
            </p>
          </div>
          <div className="max-w-3xl mx-auto">
            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 md:grid-cols-2 gap-6"
            >
              <div>
                <label htmlFor="name" className="block text-gray-700 mb-2">
                  Your Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleFormChange}
                  className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-gray-700 mb-2">
                  Your Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleFormChange}
                  className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label htmlFor="phone" className="block text-gray-700 mb-2">
                  📞 Your Phone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleFormChange}
                  className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div className="md:col-span-2">
                <label htmlFor="subject" className="block text-gray-700 mb-2">
                  Enter Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleFormChange}
                  className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div className="md:col-span-2">
                <label
                  htmlFor="description"
                  className="block text-gray-700 mb-2"
                >
                  Project Description
                </label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleFormChange}
                  rows={5}
                  className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                ></textarea>
              </div>
              <div className="md:col-span-2 text-center">
                <button
                  style={{ background: "darkblue", color: "white" }}
                  type="submit"
                  className="px-8 py-3 rounded-md font-medium hover:bg-blue-700 transition-colors"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default ItService;
